import processHighlightOwningNode from '../../util/density/processHighlightOwningNode';
import processNonHighlightOwningNode from '../../util/density/processNonHighlightOwningNode';

import * as d3 from 'd3';
import highlightSelectedRange from '../../util/density/highlightSelectedRange';
import CalculatePreviewHighlightDensity from '../../util/density/CalculatePreviewHighlightDensity';
import Vue from 'vue';


const updateHighlightsAndKL = () => {

  // console.log('updateHighlightsAndKL was triggered');

  /************************************************************************************************************ 
    This function is triggered via two events:
    (1) The highlight slider is changed in the popup
    (2) The graph was compiled again (because values changed)
    
    The function first needs to process the data of the highlight-owning node (if there is one).
    And only after updating the global highlights, the data of all nodes can be processed.

    The data is access from the global variables (globalNodeData) that get updated after every compile.
  *************************************************************************************************************/


  // TODO: 
  // We may have to use a (U)UID instead of node id here to identify the highlight-owning node
  // Temporary fix: Assume the node.id is unique.
  // Next best solution: Determine module names as well to make node.id unique.
  // Best solution: Find a way to determine UUID of highlight-owning node and let VueDistPreviews know which node UUID they correspond to
  // VueDistPreviews do not need UUID, they just need to get the right data for their node.id since they will only update in the currently visible module.


  /*********************************************************************************
    Highlight-owning node
    ---------------------
    First, process data of the highlight-owning node.
    At the end of this, the VueDistPreview for the highlight node has been updated.
    If there is no highlight-owning node, nothing will updated in the function.
  **********************************************************************************/

  processHighlightOwningNode();
  

  /*****************************************************
    All other nodes
    ---------------------
    Process data of all other nodes 
  *****************************************************/

  // For all nodes in the global node data object, call the function to update the highlights etc.
  // The function will only execute for nodes that are not highlight-owners
  // The function also checks if there is a highlight defined at all
  for (let [key, value] of Object.entries(Vue.prototype.$globalSharedData.globalNodeData)) {
    processNonHighlightOwningNode(key)
  }


}


export default updateHighlightsAndKL;

  

  